import useAppStore from '@/store/app';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAllowedRoutes from '@/hooks/useAllowedRoutes';

const toolsNavigationItems = [
  {
    title: 'Besucher:innen',
    slug: 'visitors',
  },
  {
    title: 'Werkzeuge',
    slug: 'tools',
  },
  {
    title: 'Zeitbuchungen',
    slug: 'timeentries',
  },
];

export default function OfficeLayout() {
  const { setNavigation } = useAppStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const allowedOfficeRoutes = useAllowedRoutes('/office', toolsNavigationItems);

  useEffect(() => {
    setNavigation({
      base: '/office',
      items: toolsNavigationItems,
    });

    if (pathname === '/office' && allowedOfficeRoutes.length > 0) {
      const firstAllowedItem = allowedOfficeRoutes[0];
      let redirectToSlug;

      if (firstAllowedItem.subitems && firstAllowedItem.subitems.length > 0) {
        redirectToSlug = firstAllowedItem.subitems[0].slug;
      } else {
        redirectToSlug = firstAllowedItem.slug;
      }

      if (redirectToSlug) {
        navigate(`/office/${redirectToSlug}`, { replace: true });
      }
    }
  }, [pathname, setNavigation, navigate, allowedOfficeRoutes]);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
      <Box
        sx={{
          flexGrow: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          width: '100%',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
